module.exports = __webpack_public_path__ + "e47fbd38e7354466ac72bbe8429b6876.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/von-talin-sprite.png
// module id = alge
// module chunks = 0